<template v-show="show">
  <div v-if="event.sptid=='1'">
    <div v-if="hasOneX2BTTS || hasCS || hasBooking || hasCorner || simpleSport!=null">
      <!-- More Bet Type Row -->
      <div class="other-play-tab">
        <div class="play-title col">
          <div class="arrow-wrap yb-flex-center" @click="openMoreBetForm(event,'arrow')" v-if="(hasCS || (hasOneX2BTTS && !simpleSport) || (hasBooking && !simpleSport) || (hasCorner && !simpleSport))">
            <div class="yb-icon-arrow" :id="'moreBet' + event.eveid" :class="{ active: !showMoreBet }"></div>
          </div>
          <div class="tab-wrap fit relative-position">
            <div id="more-tab" class="item-wrap relative-position" style="left: 0px;">
              <div v-if="hasCS" class="tab-item yb-flex-center" :class="['cstab-' + event.eveid, { active: (selectedMarket ==  mBetTab.cs.key) }]"
                @click="chooseMarketType(mBetTab.cs, event, '.cstab-' + event.eveid)">{{
                  sportAllBetLang['ALL_BET.SUBHEADER_CS'] }}
              </div>
              <div v-if="hasOneX2BTTS && !simpleSport" class="tab-item yb-flex-center"  :class="['mmtab-' + event.eveid, { active: (selectedMarket ==  mBetTab.onex2btts.key) }]"
                @click="chooseMarketType(mBetTab.onex2btts, event,'.mmtab-' + event.eveid)">{{
                  sportAllBetLang['ALL_BET.MIXMARKET'] }}
              </div>
              <div v-if="hasBooking && !simpleSport" class="tab-item yb-flex-center"  :class="['bookingtab-' + event.eveid, { active: (selectedMarket ==  mBetTab.booking.key) }]"
                @click="chooseMarketType(mBetTab.booking, event,'.bookingtab-' + event.eveid)">{{
                  sportAllBetLang['ALL_BET.LBL_BOOKING'] }}
              </div>
              <div v-if="hasCorner && !simpleSport" class="tab-item yb-flex-center"  :class="['cornertab-' + event.eveid, { active: (selectedMarket ==  mBetTab.corner.key) }]"
                @click="chooseMarketType(mBetTab.corner, event,'.cornertab-' + event.eveid)">{{
                  sportAllBetLang['ALL_BET.LBL_CORNER'] }}
              </div>
            </div>
          </div>
        </div>
        <div class="media-col" style="min-width: 41px !important;" v-if="!simpleSport"></div>
      </div>
      <template v-if="showMoreBet">
        <template v-if="simpleSport">
          <!-- PlyType Header -->
          <div class="fifteen-box">
            <div class="basic-col" :style="{ width: widthColumn[0] + 'px !important' }"></div>
            <div class="vrow">
              <div class="handicap-col fifteen-item bet-item-wrap fifteen_tab_txt" :style="{ width: (widthColumn[1]*3) + 'px !important' }">
                {{ sportAllBetLang['ALL_BET.LBL_FT'] }}
              </div>
              <div class="handicap-col fifteen-item bet-item-wrap fifteen_tab_txt tab-tilte-bg highlight-t" style="flex:1;" :style="{ width: (widthColumn[1]*3) + 'px !important' }">
                {{ sportTableLang.template_lang['SPORT_TEMPLATE_1.FIRST_HALF'] }}
              </div>
            </div>
          </div>
        </template>
        <!-- Header -->
        <div class="fifteen-box" :ref="'showmoreBet' + event.eveid">
          <div class="basic-col" :style="{ width: widthColumn[0] + 'px !important' }"></div>
          <mbHeader :event="filteredMainMarketList" :selMarket="selectedMarket" :widthColumn="widthColumn" :isUnfold="isUnfold"></mbHeader>
        </div>
        <!-- Odds -->
        <div class="match-handicap-item other-handicap-item" :ref="'moreBetmatches' + event.eveid">
          <template v-if="!moreBetLoading">
            <sportTeam :event="filteredMainMarketList" :selMarket="selectedMarket" :mode="'morebet'" :widthL="widthColumn[0]" :specialEveId="specialEveId"></sportTeam>
            <template v-if="(selectedMarket ==  mBetTab.cs.key)">
              <moreCS :event="filteredMainMarketList" :widthColumn="widthColumn" :isUnfold="isUnfold"></moreCS>
            </template>
            <template v-if="(selectedMarket ==  mBetTab.onex2btts.key)">
              <more1x2btts :event="filteredMainMarketList" :widthColumn="widthColumn" :isUnfold="isUnfold"></more1x2btts>
            </template>
            <template v-if="(selectedMarket ==  mBetTab.booking.key)">
              <moreSpecial :event="filteredMainMarketList" :widthColumn="widthColumn" :isUnfold="isUnfold" :specialType="mBetTab.booking.key" :specialEveId="specialEveId"></moreSpecial>
            </template>
            <template v-if="(selectedMarket ==  mBetTab.corner.key)">
              <moreSpecial :event="filteredMainMarketList" :widthColumn="widthColumn" :isUnfold="isUnfold" :specialType="mBetTab.corner.key" :specialEveId="specialEveId"></moreSpecial>
            </template>
            <div class="media-col"></div>
          </template>
        </div>

      </template>
    </div>
  </div>
</template>

<script>
import {
  mapGetters,
} from 'vuex'
import vueCookie from 'vue-cookie'

import DateFilter from '@/vue/filters/date'

import cstgftht from '../../../components/cs-tg-ftht'
import bttstgft from '../../../components/btts-tg-ft'

import mbHeader from './more-bet-header'
import moreCS from './moreBet-cs'
import more1x2btts from './moreBet-1x2btts'
import moreSpecial from './moreBet-special'
import sportTeam from '../sportTeamColumn'

import allBetMixin from '../../../mixins/allBet'

import EventBus from '@/vue/events/event-bus'

export default {
  mixins: [allBetMixin],
  components: {
    mbHeader,
    moreCS,
    sportTeam,
    more1x2btts,
    moreSpecial,
  },
  props: {
    event: null,
    widthColumn:null,
    isUnfold:false,
  },
  computed: {
    ...mapGetters([
      'eventAllBet',
      'selectedShow',
      'selectedBettype',
      'moreBetLoading',
      'moreBetToggle',
      'myMarketList',
      'firstEvent',
      'simpleSport',
      'bettypeFeature',
    ]),
    filteredMainMarketList() {
      this.specialEveId = null
      // Filter more bet bet type odd 
      var eventAllBet = _.cloneDeep(this.event)
      switch (this.selectedMarket) {
        case this.mBetTab.cs.key:
          eventAllBet = this.getCSOdd(eventAllBet)
          break;
        case this.mBetTab.onex2btts.key:
          eventAllBet = this.getOnex2bttsOdd(eventAllBet)
        break;
        case this.mBetTab.booking.key:
          eventAllBet = this.getSpecialOdd(eventAllBet, this.mBetTab.booking.value)
        break;
        case this.mBetTab.corner.key:
          eventAllBet = this.getSpecialOdd(eventAllBet, this.mBetTab.corner.value)
        break;
        default:
        //nothing
      }
      return eventAllBet
    },
    sortedMatchEventList: {
      get() {
        this.mainMarketList = _.cloneDeep(this.$store.getters.sortedMatchEventList)
        return this.$store.getters.sortedMatchEventList
      },
      set(value) {
        // this.$store.commit('SPORT_SHOW_FAV_EVENTS', value)
        // EventBus.$emit('refreshOdd', true)
        // this.$store.dispatch('getSportOdds',{
        //   callback: ((res) => {
        //     this.refreshTimer()
        //     this.refreshScroll()
        //   }).bind(this)
        // })
      }
    },
    hasCS() {
      return this.checkMBTexist(this.event, this.mBetTab.cs.key);
    },
    hasOneX2BTTS() {
      return this.checkMBTexist(this.event, this.mBetTab.onex2btts.key);
    },
    hasBooking() {
      return this.checkMBTexist(this.event, this.mBetTab.booking.key);
    },
    hasCorner() {
      return this.checkMBTexist(this.event, this.mBetTab.corner.key);
    },
  },
  updated() {
    // if(this.selectedBettype.sprtId=='N1'){ //SC
    //   if (this.showMoreBet && this.clickMoreBet) {
    //     var xParent1 = this.$parent.$refs['eCardWrap'+this.event.eveid][0].offsetHeight
    //     var xParent2 = this.$parent.$refs['eCard'+this.event.eveid][0].offsetHeight
    //     var mbetHeader = 40
    //     this.childHeight = this.$refs['moreBetmatches'+this.event.eveid].offsetHeight + mbetHeader
        
    //     var p1 = xParent1 + this.childHeight + mbetHeader
    //     var p2 = xParent2 + this.childHeight + mbetHeader
    //     document.getElementById('eCardWrap'+this.event.eveid).style.height = p1+"px";
    //     document.getElementById('eCard'+this.event.eveid).style.height = p2+"px";
    //     this.clickMoreBet = false

    //   }else if (!this.showMoreBet && !this.clickMoreBet) {
    //     var xParent1 = this.$parent.$refs['eCardWrap'+this.event.eveid][0].offsetHeight
    //     var xParent2 = this.$parent.$refs['eCard'+this.event.eveid][0].offsetHeight
    //     // var xChild = this.$refs['moreBetmatches'+this.event.eveid].offsetHeight
    //     var p1 = xParent1 - this.childHeight
    //     var p2 = xParent2 - this.childHeight
    //     document.getElementById('eCardWrap'+this.event.eveid).style.height = p1+"px";
    //     document.getElementById('eCard'+this.event.eveid).style.height = p2+"px";
    //     this.clickMoreBet = false
    //   }
    // }
  
  },
  data() {
    return {
      lang: window.lang,
      mBetTab: {
        cs: {
          key: 'cs',
          value: [7],     //cs bt id in allbet mixin
          rbvalue: [16],  //rcs
          flag: true,
        },
        onex2btts: {
          key: 'onex2btts',
          value: [65,70],     //onex2btts,dbchbtts bt id in allbet mixin
          rbvalue: [66,71],   //ronex2btts,rdbchbtts
          flag: true,
        },
        dbchbtts: {
          key: 'dbchbtts',
          value: [70],      //dbchbtts bt id in allbet mixin
          rbvalue: [71],    //rdbchbtts
          flag: true,
        },
        booking: {
          key: 'booking',
          value: "b",
          flag: true,
        },
        corner: {
          key: 'corner',
          value: "c",
          flag: true,
        },
      },
      cloneEventAllBet: null,
      mainMarketList: null,
      showMyMarkets: false,
      showMainMarkets: true,
      allBetRefreshTimer: 90,
      allBetTimerId: null,
      // myMarketList: null,
      selectedMarket: null,
      token: window.token,
      isRB: false,
      showMoreBet: false,
      show: true,
      childHeight: 0,
      clickMoreBet: false, 
      moreBetmatchesHeight: 0,
      xParent1:0,
      xParent2:0,
      ousub:null,
      specialEveId:null,
    }
  },
  methods: {
    checkMBTexist(event, btKey) {
      let vue = this
      let exist = false
      let btArray = (event.rbinfo) ? vue.mBetTab[btKey].rbvalue : vue.mBetTab[btKey].value

      if (btKey == this.mBetTab.cs.key) {
        _.forEach(event.od, function (data, key) {
          _.forEach(data, function (val, k) {
            if ($.inArray(parseInt(k), btArray) > -1) {
              exist = true
            }
          })
        })
      }
      
      if(btKey == this.mBetTab.onex2btts.key || btKey == this.mBetTab.dbchbtts.key){
        _.forEach(event.od, function (data, key) {
          _.forEach(data, function (val, k) {
            if ($.inArray(parseInt(k), btArray) > -1) {
              exist = true
            }
          })
        })

        if (this.bettypeFeature) {
          _.forEach(btArray, function (val, k) {
            if (_.includes(vue.bettypeFeature, String(val))) {
              exist = false;
            }
          })
        }
      }

      if (btKey == this.mBetTab.booking.key) {
        $.each(event.sp, function (key, value) {
          if (value.r == "b" && value.od){
            exist = true
            return false
          }
        });
      }
      
      if (btKey == this.mBetTab.corner.key) {
        $.each(event.sp, function (key, value) {
          if (value.r == "c" && value.od){
            exist = true
            return false
          }
        });
      }

      this.show = (exist || this.simpleSport!=null) ? true : false
      return exist
    },
    setTabActive(event){
      let vue = this
      let existCs = 0
      let bttsArray = (event.rbinfo) ? vue.mBetTab['onex2btts'].rbvalue : vue.mBetTab['onex2btts'].value
      let csArray = (event.rbinfo) ? vue.mBetTab['cs'].rbvalue : vue.mBetTab['cs'].value

      _.forEach(event.od, function (data, key) {
        _.forEach(data, function (val, k) {
          if ($.inArray(parseInt(k), csArray) > -1) {
            existCs = 1;
            return false;
          }else if($.inArray(parseInt(k), bttsArray) > -1){
            existCs = 2;
            return false;
          }
        })
      })

      return existCs

    },
    openMoreBetForm(event,clickFrom) {
      var expanded = $('#moreBet' + event.eveid).hasClass('active')
      var csForm =  $('.cstab-' + event.eveid).hasClass('active')
      var mmForm =  $('.mmtab-' + event.eveid).hasClass('active')
      var bookingForm =  $('.bookingtab-' + event.eveid).hasClass('active')
      var cornerForm =  $('.cornertab-' + event.eveid).hasClass('active')
      var mbetHeader = (this.simpleSport)? 80:40

      if(csForm){
        this.selectedMarket = this.mBetTab.cs.key 
      }else if(mmForm){
        this.selectedMarket = this.mBetTab.onex2btts.key 
      }else if(bookingForm){
        this.selectedMarket = this.mBetTab.booking.key 
      }else if(cornerForm){
        this.selectedMarket = this.mBetTab.corner.key 
      } else {
        if(this.hasCS) this.selectedMarket = this.mBetTab.cs.key
        else if(this.hasOneX2BTTS) this.selectedMarket = this.mBetTab.onex2btts.key
        else if(this.hasBooking) this.selectedMarket = this.mBetTab.booking.key
        else if(this.hasCorner) this.selectedMarket = this.mBetTab.corner.key
      }

      if (expanded) {
        this.$store.commit('MOREBETLOADING', true)
        this.$store.dispatch('getSportAllBet', {
          event: event,
          token: token.arr_8,
          callback: ((res) => {
            this.showMoreBet = true
            this.clickMoreBet = true
            this.$store.commit('MOREBETLOADING', false)
            this.$nextTick(() => {
              if (this.showMoreBet && this.clickMoreBet) {
                this.xParent1 = (this.$parent.$refs['eCardWrap'+this.event.eveid] && this.$parent.$refs['eCardWrap'+this.event.eveid].length > 0)? this.$parent.$refs['eCardWrap'+this.event.eveid][0].offsetHeight:this.$parent.$refs['eCardWrap'+this.event.eveid].offsetHeight  //285
                this.xParent2 = (this.$parent.$refs['eCard'+this.event.eveid] && this.$parent.$refs['eCard'+this.event.eveid].length > 0)? this.$parent.$refs['eCard'+this.event.eveid][0].offsetHeight:this.$parent.$refs['eCard'+this.event.eveid].offsetHeight //285
                this.childHeight = this.$refs['moreBetmatches'+this.event.eveid].offsetHeight + mbetHeader
                var p1 = this.xParent1 + this.childHeight
                var p2 = this.xParent2 + this.childHeight
                document.getElementById('eCardWrap'+this.event.eveid).style.height = p1+"px";
                document.getElementById('eCard'+this.event.eveid).style.height = p2+"px";
                this.clickMoreBet = false
              }
            })
          }).bind(this)
        })
      } else {
        if(clickFrom == 'arrow'){
          //only click the arrow able to hide the more bet form
          this.showMoreBet = false
        }
        if(this.showMoreBet && !this.clickMoreBet){
          this.$nextTick(() => {
            //   var moreBetmatches = this.$refs['moreBetmatches' + this.event.eveid];
            //   this.moreBetmatchesHeight = moreBetmatches ? moreBetmatches.offsetHeight : 0;
            var p1 = $('#eCard'+this.event.eveid).children().height() + 6;
            var p2 = $('#eCard'+this.event.eveid).children().height() + 3;

            document.getElementById('eCardWrap'+this.event.eveid).style.height  = p1+"px";
            document.getElementById('eCard'+this.event.eveid).style.height      = p2+"px";
          });
        }else if (!this.showMoreBet && !this.clickMoreBet) {
          var xParent1    = (this.$parent.$refs['eCardWrap'+this.event.eveid] && this.$parent.$refs['eCardWrap'+this.event.eveid].length > 0)? this.$parent.$refs['eCardWrap'+this.event.eveid][0].offsetHeight:this.$parent.$refs['eCardWrap'+this.event.eveid].offsetHeight
          var xParent2    = (this.$parent.$refs['eCard'+this.event.eveid] && this.$parent.$refs['eCard'+this.event.eveid].length > 0)? this.$parent.$refs['eCard'+this.event.eveid][0].offsetHeight:this.$parent.$refs['eCard'+this.event.eveid].offsetHeight
          var childHeight = this.$refs['moreBetmatches'+this.event.eveid].offsetHeight + mbetHeader
          var p1          = xParent1 - childHeight
          var p2          = xParent2 - childHeight
          document.getElementById('eCardWrap'+this.event.eveid).style.height = p1+"px";
          document.getElementById('eCard'+this.event.eveid).style.height = p2+"px";
          this.clickMoreBet = false
        }
      }
    },
    updateElementHeights(newHeight) {
      var mbetHeader = 40

      var p1 = this.xParent1 + newHeight + mbetHeader;
      var p2 = this.xParent2 + newHeight + mbetHeader;

      document.getElementById('eCardWrap' + this.event.eveid).style.height = p1 + "px";
      document.getElementById('eCard' + this.event.eveid).style.height = p2 + "px";
    },
    rbdata() {
      this.isRB = (this.filteredMainMarketList.event_rb == '1' || this.filteredMainMarketList.rbinfo || this.filteredMainMarketList.status == '1') ? true : false;
      return this.isRB
    },
    chkShow(sportId, betType, plyType) {
      if (sportId == 13) { // american football
        if (plyType == 1 && betType != 3 && betType != 10) {
          return false
        }
      } else if (sportId == 1) { // soccer 
        if (this.$store.getters.selectedShow != 4 && plyType == 1 && (betType == 1 || betType == 2 || betType == 4 || betType == 8 || betType == 9 || betType == 11)) {
          if (this.$store.getters.selectedShow == 3 && (betType == 4 || betType == 11)) {  // Full Time
          } else if (this.$store.getters.selectedShow == 1 && (betType == 4 || betType == 11)) {  // single line
          } else {
            return false
          }
        } else if (this.$store.getters.selectedShow != 3 && plyType == 2 && (betType == 1 || betType == 2 || betType == 4 || betType == 8 || betType == 9 || betType == 11)) {
          if (this.$store.getters.selectedShow == 4 && (betType == 4 || betType == 11)) {  // Full Time
          } else if (this.$store.getters.selectedShow == 1 && (betType == 4 || betType == 11)) {  // single line
          } else {
            return false
          }
        }
      } else if (plyType == 1 || plyType == 3) {
        return false
      }
      return true
    },
    closeAllBetForm() {
      this.$store.commit('SELECTED_ALLBET', false)
    },
    backToTop() {
      document.getElementById("more_div").scrollTop = "0";
    },
    countOddsType(marKetList) {
      var count = 0;

      function getOddsCount(event) {
        var odCount = 0
        for (var plytyp = 0; plytyp < Object.keys(event.od).length; plytyp++) {
          var plytypKey = Object.keys(event.od)[plytyp]
          for (var bettyp = 0; bettyp < Object.keys(event.od[plytypKey]).length; bettyp++) {
            var bettypKey = Object.keys(event.od[plytypKey])[bettyp]
            //hdp, ou count submatch
            if (_.indexOf([this.hdpBetType, this.ouBetType, this.rhdpBetType, this.rouBetType], bettypKey) >= 0) {
              odCount += Object.keys(event.od[plytypKey][bettypKey]).length
            } else {
              odCount += 1
            }
          }
        }
        return odCount
      }

      var getCount = getOddsCount.bind(this)
      count += getCount(marKetList)
      if (marKetList.sp) {
        for (var eventId = 0; eventId < Object.keys(marKetList.sp).length; eventId++) {
          var event = marKetList.sp[Object.keys(marKetList.sp)[eventId]]
          count += getCount(event)
        }
      }
      return count
    },
    syncMainMarket() {
      if (this.myMarketList) {
        if (this.myMarketList.od[this.ftPlyType]) {
          var ftBetTyp = _.pick(this.mainMarketList.od[this.ftPlyType], Object.keys(this.myMarketList.od[this.ftPlyType]))
          this.$set(this.myMarketList.od, this.ftPlyType, ftBetTyp)
          for (var i = Object.keys(this.myMarketList.od[this.ftPlyType]).length - 1; i >= 0; i--) {
            this.$delete(this.mainMarketList.od[this.ftPlyType], Object.keys(this.myMarketList.od[this.ftPlyType])[i])
          }
        }
        if (this.myMarketList.od[this.firstHtPlyType]) {
          var firstHtBetTyp = _.pick(this.mainMarketList.od[this.firstHtPlyType], Object.keys(this.myMarketList.od[this.firstHtPlyType]))
          this.$set(this.myMarketList.od, this.firstHtPlyType, firstHtBetTyp)
          for (var i = Object.keys(this.myMarketList.od[this.firstHtPlyType]).length - 1; i >= 0; i--) {
            this.$delete(this.mainMarketList.od[this.firstHtPlyType], Object.keys(this.myMarketList.od[this.firstHtPlyType])[i])
          }
        }
        if (this.myMarketList.od[this.setHandicapPlyType]) {
          var setHandicapBetTyp = _.pick(this.mainMarketList.od[this.setHandicapPlyType], Object.keys(this.myMarketList.od[this.setHandicapPlyType]))
          this.$set(this.myMarketList.od, this.setHandicapPlyType, setHandicapBetTyp)
          for (var i = Object.keys(this.myMarketList.od[this.setHandicapPlyType]).length - 1; i >= 0; i--) {
            this.$delete(this.mainMarketList.od[this.setHandicapPlyType], Object.keys(this.myMarketList.od[this.setHandicapPlyType])[i])
          }
        }
        if (this.myMarketList.od[this.pointHdpPlyType]) {
          var pointHandicapBetTyp = _.pick(this.mainMarketList.od[this.pointHdpPlyType], Object.keys(this.myMarketList.od[this.pointHdpPlyType]))
          this.$set(this.myMarketList.od, this.pointHdpPlyType, pointHandicapBetTyp)
          for (var i = Object.keys(this.myMarketList.od[this.pointHdpPlyType]).length - 1; i >= 0; i--) {
            this.$delete(this.mainMarketList.od[this.pointHdpPlyType], Object.keys(this.myMarketList.od[this.pointHdpPlyType])[i])
          }
        }
        if (this.myMarketList.od[this.iotPlyType]) {
          var iotBetTyp = _.pick(this.mainMarketList.od[this.iotPlyType], Object.keys(this.myMarketList.od[this.iotPlyType]))
          this.$set(this.myMarketList.od, this.iotPlyType, iotBetTyp)
          for (var i = Object.keys(this.myMarketList.od[this.iotPlyType]).length - 1; i >= 0; i--) {
            this.$delete(this.mainMarketList.od[this.iotPlyType], Object.keys(this.myMarketList.od[this.iotPlyType])[i])
          }
        }
        if (this.myMarketList.od[this.gameHdpPlyType]) {
          var gameHandicapBetTyp = _.pick(this.mainMarketList.od[this.gameHdpPlyType], Object.keys(this.myMarketList.od[this.gameHdpPlyType]))
          this.$set(this.myMarketList.od, this.gameHdpPlyType, gameHandicapBetTyp)
          for (var i = Object.keys(this.myMarketList.od[this.gameHdpPlyType]).length - 1; i >= 0; i--) {
            this.$delete(this.mainMarketList.od[this.gameHdpPlyType], Object.keys(this.myMarketList.od[this.gameHdpPlyType])[i])
          }
        }
        if (this.myMarketList.od[this.firstSetPlyType]) {
          var firstSetHandicapBetTyp = _.pick(this.mainMarketList.od[this.firstSetPlyType], Object.keys(this.myMarketList.od[this.firstSetPlyType]))
          this.$set(this.myMarketList.od, this.firstSetPlyType, firstSetHandicapBetTyp)
          for (var i = Object.keys(this.myMarketList.od[this.firstSetPlyType]).length - 1; i >= 0; i--) {
            this.$delete(this.mainMarketList.od[this.firstSetPlyType], Object.keys(this.myMarketList.od[this.firstSetPlyType])[i])
          }
        }
        if (this.myMarketList.od[this.secondSetPlyType]) {
          var secondSetHandicapBetTyp = _.pick(this.mainMarketList.od[this.secondSetPlyType], Object.keys(this.myMarketList.od[this.secondSetPlyType]))
          this.$set(this.myMarketList.od, this.secondSetPlyType, secondSetHandicapBetTyp)
          for (var i = Object.keys(this.myMarketList.od[this.secondSetPlyType]).length - 1; i >= 0; i--) {
            this.$delete(this.mainMarketList.od[this.secondSetPlyType], Object.keys(this.myMarketList.od[this.secondSetPlyType])[i])
          }
        }
        if (this.myMarketList.od[this.thirdSetPlyType]) {
          var thirdSetHandicapBetTyp = _.pick(this.mainMarketList.od[this.thirdSetPlyType], Object.keys(this.myMarketList.od[this.thirdSetPlyType]))
          this.$set(this.myMarketList.od, this.thirdSetPlyType, thirdSetHandicapBetTyp)
          for (var i = Object.keys(this.myMarketList.od[this.thirdSetPlyType]).length - 1; i >= 0; i--) {
            this.$delete(this.mainMarketList.od[this.thirdSetPlyType], Object.keys(this.myMarketList.od[this.thirdSetPlyType])[i])
          }
        }
        if (this.myMarketList.od[this.fourthSetPlyType]) {
          var fourthSetHandicapBetTyp = _.pick(this.mainMarketList.od[this.fourthSetPlyType], Object.keys(this.myMarketList.od[this.fourthSetPlyType]))
          this.$set(this.myMarketList.od, this.fourthSetPlyType, fourthSetHandicapBetTyp)
          for (var i = Object.keys(this.myMarketList.od[this.fourthSetPlyType]).length - 1; i >= 0; i--) {
            this.$delete(this.mainMarketList.od[this.fourthSetPlyType], Object.keys(this.myMarketList.od[this.fourthSetPlyType])[i])
          }
        }
        if (this.myMarketList.od[this.fifthSetPlyType]) {
          var fifthSetHandicapBetTyp = _.pick(this.mainMarketList.od[this.fifthSetPlyType], Object.keys(this.myMarketList.od[this.fifthSetPlyType]))
          this.$set(this.myMarketList.od, this.fifthSetPlyType, fifthSetHandicapBetTyp)
          for (var i = Object.keys(this.myMarketList.od[this.fifthSetPlyType]).length - 1; i >= 0; i--) {
            this.$delete(this.mainMarketList.od[this.fifthSetPlyType], Object.keys(this.myMarketList.od[this.fifthSetPlyType])[i])
          }
        }
        if (this.myMarketList.od[this.sixthSetPlyType]) {
          var sixthSetHandicapBetTyp = _.pick(this.mainMarketList.od[this.sixthSetPlyType], Object.keys(this.myMarketList.od[this.sixthSetPlyType]))
          this.$set(this.myMarketList.od, this.sixthSetPlyType, sixthSetHandicapBetTyp)
          for (var i = Object.keys(this.myMarketList.od[this.sixthSetPlyType]).length - 1; i >= 0; i--) {
            this.$delete(this.mainMarketList.od[this.sixthSetPlyType], Object.keys(this.myMarketList.od[this.sixthSetPlyType])[i])
          }
        }
        if (this.myMarketList.od[this.game1PlyType]) {
          var game1BetTyp = _.pick(this.mainMarketList.od[this.game1PlyType], Object.keys(this.myMarketList.od[this.game1PlyType]))
          this.$set(this.myMarketList.od, this.game1PlyType, game1BetTyp)
          for (var i = Object.keys(this.myMarketList.od[this.game1PlyType]).length - 1; i >= 0; i--) {
            this.$delete(this.mainMarketList.od[this.game1PlyType], Object.keys(this.myMarketList.od[this.game1PlyType])[i])
          }
        }
        if (this.myMarketList.od[this.game2PlyType]) {
          var game2BetTyp = _.pick(this.mainMarketList.od[this.game2PlyType], Object.keys(this.myMarketList.od[this.game2PlyType]))
          this.$set(this.myMarketList.od, this.game2PlyType, game2BetTyp)
          for (var i = Object.keys(this.myMarketList.od[this.game2PlyType]).length - 1; i >= 0; i--) {
            this.$delete(this.mainMarketList.od[this.game2PlyType], Object.keys(this.myMarketList.od[this.game2PlyType])[i])
          }
        }
        if (this.myMarketList.od[this.game3PlyType]) {
          var game3BetTyp = _.pick(this.mainMarketList.od[this.game3PlyType], Object.keys(this.myMarketList.od[this.game3PlyType]))
          this.$set(this.myMarketList.od, this.game3PlyType, game3BetTyp)
          for (var i = Object.keys(this.myMarketList.od[this.game3PlyType]).length - 1; i >= 0; i--) {
            this.$delete(this.mainMarketList.od[this.game3PlyType], Object.keys(this.myMarketList.od[this.game3PlyType])[i])
          }
        }
        if (this.myMarketList.od[this.game4PlyType]) {
          var game4BetTyp = _.pick(this.mainMarketList.od[this.game4PlyType], Object.keys(this.myMarketList.od[this.game4PlyType]))
          this.$set(this.myMarketList.od, this.game4PlyType, game4BetTyp)
          for (var i = Object.keys(this.myMarketList.od[this.game4PlyType]).length - 1; i >= 0; i--) {
            this.$delete(this.mainMarketList.od[this.game4PlyType], Object.keys(this.myMarketList.od[this.game4PlyType])[i])
          }
        }
        if (this.myMarketList.od[this.game5PlyType]) {
          var game5BetTyp = _.pick(this.mainMarketList.od[this.game5PlyType], Object.keys(this.myMarketList.od[this.game5PlyType]))
          this.$set(this.myMarketList.od, this.game5PlyType, game5BetTyp)
          for (var i = Object.keys(this.myMarketList.od[this.game5PlyType]).length - 1; i >= 0; i--) {
            this.$delete(this.mainMarketList.od[this.game5PlyType], Object.keys(this.myMarketList.od[this.game5PlyType])[i])
          }
        }
        if (this.myMarketList.sp) {
          for (let eveid = 0; eveid < Object.keys(this.myMarketList.sp).length; eveid++) {
            var specialEvent = this.myMarketList.sp[Object.keys(this.myMarketList.sp)[eveid]];
            for (var plytyp = Object.keys(specialEvent.od).length - 1; plytyp >= 0; plytyp--) {
              var plytypId = Object.keys(specialEvent.od)[plytyp]
              if (this.mainMarketList.sp && this.mainMarketList.sp[specialEvent.eveid] &&
                this.mainMarketList.sp[specialEvent.eveid].od[plytypId] && specialEvent.od[plytypId]
              ) {
                var betTypList = _.pick(this.mainMarketList.sp[specialEvent.eveid].od[plytypId], Object.keys(specialEvent.od[plytypId]))
                this.$set(this.myMarketList.sp[specialEvent.eveid].od, plytypId, betTypList)
                for (var bettyp = Object.keys(specialEvent.od[plytypId]).length - 1; bettyp >= 0; bettyp--) {
                  this.$delete(this.mainMarketList.sp[specialEvent.eveid].od[plytypId], Object.keys(this.myMarketList.sp[specialEvent.eveid].od[plytypId])[bettyp])
                }
              }
            }
          }
        }
      }
    },
    updateFavCookie(plytyp, bettyp, isDelete, isSpecial = false) {
      var favCookie = {}
      if (vueCookie.get(window.compcode + '_fav')) {
        favCookie = JSON.parse(vueCookie.get(window.compcode + '_fav'))
        if (!isSpecial) {
          if (!favCookie[plytyp])
            favCookie[plytyp] = {}
          favCookie[plytyp][bettyp] = {}
          if (isDelete) {
            _.unset(favCookie[plytyp], [bettyp])
            if (Object.keys(favCookie[plytyp]).length == 0) {
              _.unset(favCookie, [plytyp])
            }
          }
        } else {
          if (!favCookie.sp)
            favCookie.sp = {}
          if (!favCookie.sp[isSpecial.eveid])
            favCookie.sp[isSpecial.eveid] = {}
          if (!favCookie.sp[isSpecial.eveid][plytyp])
            favCookie.sp[isSpecial.eveid][plytyp] = {}
          favCookie.sp[isSpecial.eveid][plytyp][bettyp] = {}
          if (isDelete) {
            _.unset(favCookie.sp[isSpecial.eveid][plytyp], [bettyp])
            if (Object.keys(favCookie.sp[isSpecial.eveid][plytyp]).length == 0) {
              _.unset(favCookie.sp[isSpecial.eveid], [plytyp])
            }
            if (Object.keys(favCookie.sp[isSpecial.eveid]).length == 0) {
              _.unset(favCookie.sp, isSpecial.eveid)
            }
          }
        }
      } else {
        if (!isSpecial) {
          favCookie[plytyp] = {}
          favCookie[plytyp][bettyp] = {}
        } else {
          favCookie.sp = {}
          favCookie.sp[isSpecial.eveid] = {}
          favCookie.sp[isSpecial.eveid][plytyp] = {}
          favCookie.sp[isSpecial.eveid][plytyp][bettyp] = {}
        }
      }
      vueCookie.set(window.compcode + '_fav', JSON.stringify(favCookie))
    },
    getFavCookieMarket() {
      var favCookie = {}
      if (vueCookie.get(window.compcode + '_fav')) {
        favCookie = JSON.parse(vueCookie.get(window.compcode + '_fav'))
        for (var plytyp = Object.keys(favCookie).length - 1; plytyp >= 0; plytyp--) {
          var pt = Object.keys(favCookie)[plytyp]
          if (pt != 'sp') {
            for (var bettyp = Object.keys(favCookie[pt]).length - 1; bettyp >= 0; bettyp--) {
              var bt = Object.keys(favCookie[pt])[bettyp]
              if (this.$store.getters.eventAllBet.od[pt]) {
                if (this.$store.getters.eventAllBet.od[pt][bt]) {
                  this.pickMarket(this.$store.getters.eventAllBet, pt, bt)
                }
              }
            }
          } else {
            for (var eve = Object.keys(favCookie.sp).length - 1; eve >= 0; eve--) {
              var eveid = Object.keys(favCookie.sp)[eve]
              for (var plytyp = Object.keys(favCookie.sp[eveid]).length - 1; plytyp >= 0; plytyp--) {
                var pt = Object.keys(favCookie.sp[eveid])[plytyp]
                for (var bettyp = Object.keys(favCookie.sp[eveid][pt]).length - 1; bettyp >= 0; bettyp--) {
                  var bt = Object.keys(favCookie.sp[eveid][pt])[bettyp]
                  var bt = Object.keys(favCookie.sp[eveid][pt])[bettyp]['a']
                  if (this.$store.getters.eventAllBet.sp && this.$store.getters.eventAllBet.sp[eveid]) {
                    if (this.$store.getters.eventAllBet.sp[eveid].od[pt]) {
                      if (this.$store.getters.eventAllBet.sp[eveid].od[pt][bt]) {
                        this.pickMarket(this.$store.getters.eventAllBet.sp[eveid], pt, bt, true)
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      return {}
    },
    pickMarket(market, plytyp, bettyp, isSpecial = false) {
      if (this.myMarketList) {
        if (!isSpecial) {
          if (!this.myMarketList.od[plytyp]) {
            this.$set(this.myMarketList.od, plytyp, {})
          }
          this.$set(this.myMarketList.od[plytyp], bettyp, market.od[plytyp][bettyp])
        } else {
          !this.myMarketList.sp ? this.$set(this.myMarketList, 'sp', {}) : this.myMarketList.sp
          !this.myMarketList.sp[market.eveid] ? this.$set(this.myMarketList.sp, market.eveid, {}) : this.myMarketList.sp[market.eveid]
          //refresh special team info
          let copyMarket = _.cloneDeep(market)
          _.unset(copyMarket, 'od')
          _.assign(this.myMarketList.sp[market.eveid], copyMarket)

          !this.myMarketList.sp[market.eveid].od ? this.$set(this.myMarketList.sp[market.eveid], 'od', {}) : this.myMarketList.sp[market.eveid].od
          !this.myMarketList.sp[market.eveid].od[plytyp] ? this.$set(this.myMarketList.sp[market.eveid].od, plytyp, {}) : this.myMarketList.sp[market.eveid].od[plytyp]
          this.$set(this.myMarketList.sp[market.eveid].od[plytyp], bettyp, market.od[plytyp][bettyp])
        }
      } else { //first pick
        this.myMarketList = _.cloneDeep(this.$store.getters.eventAllBet)
        this.$set(this.myMarketList, 'od', {})
        this.$set(this.myMarketList, 'sp', {})
        if (!isSpecial) {
          this.$set(this.myMarketList.od, plytyp, {})
          this.$set(this.myMarketList.od[plytyp], bettyp, market.od[plytyp][bettyp])
        } else {
          this.$set(this.myMarketList.sp, market.eveid, _.cloneDeep(market))
          this.$set(this.myMarketList.sp[market.eveid], 'od', {})
          this.$set(this.myMarketList.sp[market.eveid].od, plytyp, {})
          this.$set(this.myMarketList.sp[market.eveid].od[plytyp], bettyp, market.od[plytyp][bettyp])
        }
        this.showMyMarkets = true
      }
      !isSpecial ? this.updateFavCookie(plytyp, bettyp, false) : this.updateFavCookie(plytyp, bettyp, false, market)
      !isSpecial ? this.$delete(this.mainMarketList.od[plytyp], bettyp) : this.$delete(this.mainMarketList.sp[market.eveid].od[plytyp], bettyp)
    },
    removeFromMyMarket(market, plytyp, bettyp, isSpecial = false) {
      if (!isSpecial) {
        this.$set(this.mainMarketList.od[plytyp], bettyp, market.od[plytyp][bettyp])
        if (Object.keys(this.myMarketList.od[plytyp]).length > 1)
          this.$delete(this.myMarketList.od[plytyp], bettyp)
        else
          this.$delete(this.myMarketList.od, plytyp)

        if (Object.keys(this.myMarketList.od).length == 0)
          this.myMarketList = null
      } else {
        this.$set(this.mainMarketList.sp[market.eveid].od[plytyp], bettyp, market.od[plytyp][bettyp])
        if (Object.keys(this.myMarketList.sp[market.eveid].od[plytyp]).length > 1)
          this.$delete(this.myMarketList.sp[market.eveid].od[plytyp], bettyp)
        else
          this.$delete(this.myMarketList.sp[market.eveid].od, plytyp)

        if (Object.keys(this.myMarketList.sp[market.eveid].od).length == 0)
          this.$delete(this.myMarketList.sp, market.eveid)
        if (Object.keys(this.myMarketList.sp).length == 0)
          this.$delete(this.myMarketList, 'sp')
      }
      //need to support special
      !isSpecial ? this.updateFavCookie(plytyp, bettyp, true) : this.updateFavCookie(plytyp, bettyp, true, market)
    },
    getHdpOUOdd(event) {
      if (event.od[this.ftPlyType])
        event.od[this.ftPlyType] = _.pick(event.od[this.ftPlyType], this.market.hdpou.value);
      if (event.od[this.firstHtPlyType])
        event.od[this.firstHtPlyType] = _.pick(event.od[this.firstHtPlyType], this.market.hdpou.value);
      if (event.od[this.setHandicapPlyType])
        event.od[this.setHandicapPlyType] = _.pick(event.od[this.setHandicapPlyType], this.market.hdpou.value);
      if (event.od[this.pointHandicapPlyType])
        event.od[this.pointHandicapPlyType] = _.pick(event.od[this.pointHandicapPlyType], this.market.hdpou.value);
      if (event.od[this.iotPlyType])
        event.od[this.iotPlyType] = _.pick(event.od[this.iotPlyType], this.market.hdpou.value);
      if (event.od[this.gameHdpPlyType])
        event.od[this.gameHdpPlyType] = _.pick(event.od[this.gameHdpPlyType], this.market.hdpou.value);
      if (event.od[this.firstSetPlyType])
        event.od[this.firstSetPlyType] = _.pick(event.od[this.firstSetPlyType], this.market.hdpou.value);
      if (event.od[this.secondSetPlyType])
        event.od[this.secondSetPlyType] = _.pick(event.od[this.secondSetPlyType], this.market.hdpou.value);
      if (event.od[this.thirdSetPlyType])
        event.od[this.thirdSetPlyType] = _.pick(event.od[this.thirdSetPlyType], this.market.hdpou.value);
      if (event.od[this.fourthSetPlyType])
        event.od[this.fourthSetPlyType] = _.pick(event.od[this.fourthSetPlyType], this.market.hdpou.value);
      if (event.od[this.fifthSetPlyType])
        event.od[this.fifthSetPlyType] = _.pick(event.od[this.fifthSetPlyType], this.market.hdpou.value);
      if (event.od[this.sixthSetPlyType])
        event.od[this.sixthSetPlyType] = _.pick(event.od[this.sixthSetPlyType], this.market.hdpou.value);
      if (event.od[this.game1PlyType])
        event.od[this.game1PlyType] = _.pick(event.od[this.game1PlyType], this.market.hdpou.value);
      if (event.od[this.game2PlyType])
        event.od[this.game2PlyType] = _.pick(event.od[this.game2PlyType], this.market.hdpou.value);
      if (event.od[this.game3PlyType])
        event.od[this.game3PlyType] = _.pick(event.od[this.game3PlyType], this.market.hdpou.value);
      if (event.od[this.game4PlyType])
        event.od[this.game4PlyType] = _.pick(event.od[this.game4PlyType], this.market.hdpou.value);
      if (event.od[this.game5PlyType])
        event.od[this.game5PlyType] = _.pick(event.od[this.game5PlyType], this.market.hdpou.value);
      return event
    },
    getCSOdd(event) {
      var csBT = (event.rbinfo) ? this.mBetTab.cs.rbvalue : this.mBetTab.cs.value

      if (event.od[this.ftPlyType])
        event.od[this.ftPlyType] = _.pick(event.od[this.ftPlyType], csBT);
      if (event.od[this.firstHtPlyType])
        event.od[this.firstHtPlyType] = _.pick(event.od[this.firstHtPlyType], csBT);

      return event
    },
    getOnex2bttsOdd(event) {
      var onex2bttsBT = (event.rbinfo) ? this.mBetTab.onex2btts.rbvalue : this.mBetTab.onex2btts.value

      if (event.od[this.ftPlyType])
        event.od[this.ftPlyType] = _.pick(event.od[this.ftPlyType], onex2bttsBT);
      if (event.od[this.firstHtPlyType])
        event.od[this.firstHtPlyType] = _.pick(event.od[this.firstHtPlyType], onex2bttsBT);
        return event
    },
    getSpecialOdd(event, specialType) {
      this.specialEveId = Object.keys(event.sp).find(key => event.sp[key].r === specialType);

      if (!this.specialEveId) return event;

      var event_ret = {
          ...event,
          eveid: +this.specialEveId,
          lgecapt: event.sp[this.specialEveId].lgecapt,
          lgeid: event.sp[this.specialEveId].lgeid,
          tacapt: event.sp[this.specialEveId].tacapt,
          taid: event.sp[this.specialEveId].taid,
          tbcapt: event.sp[this.specialEveId].tbcapt,
          tbid: event.sp[this.specialEveId].tbid,
          od: event.sp[this.specialEveId].od,
          sp: { [this.specialEveId]: event.sp[this.specialEveId] },
          ...(event.sp_rbinfo ? { [this.specialEveId]: event.sp_rbinfo[this.specialEveId] } : {})
      };

      return event_ret;
    },
    getScoreMarketOdd(event) {
      if (event.od[this.ftPlyType])
        event.od[this.ftPlyType] = _.pick(event.od[this.ftPlyType], this.market.scrMarket.value);
      if (event.od[this.firstHtPlyType])
        event.od[this.firstHtPlyType] = _.pick(event.od[this.firstHtPlyType], this.market.scrMarket.value);
      if (event.od[this.setHandicapPlyType])
        event.od[this.setHandicapPlyType] = _.pick(event.od[this.setHandicapPlyType], this.market.scrMarket.value);
      if (event.od[this.pointHandicapPlyType])
        event.od[this.pointHandicapPlyType] = _.pick(event.od[this.pointHandicapPlyType], this.market.scrMarket.value);
      if (event.od[this.iotPlyType])
        event.od[this.iotPlyType] = _.pick(event.od[this.iotPlyType], this.market.scrMarket.value);
      if (event.od[this.gameHdpPlyType])
        event.od[this.gameHdpPlyType] = _.pick(event.od[this.gameHdpPlyType], this.market.scrMarket.value);
      if (event.od[this.firstSetPlyType])
        event.od[this.firstSetPlyType] = _.pick(event.od[this.firstSetPlyType], this.market.scrMarket.value);
      if (event.od[this.secondSetPlyType])
        event.od[this.secondSetPlyType] = _.pick(event.od[this.secondSetPlyType], this.market.scrMarket.value);
      if (event.od[this.thirdSetPlyType])
        event.od[this.thirdSetPlyType] = _.pick(event.od[this.thirdSetPlyType], this.market.scrMarket.value);
      if (event.od[this.fourthSetPlyType])
        event.od[this.fourthSetPlyType] = _.pick(event.od[this.fourthSetPlyType], this.market.scrMarket.value);
      if (event.od[this.fifthSetPlyType])
        event.od[this.fifthSetPlyType] = _.pick(event.od[this.fifthSetPlyType], this.market.scrMarket.value);
      if (event.od[this.sixthSetPlyType])
        event.od[this.sixthSetPlyType] = _.pick(event.od[this.sixthSetPlyType], this.market.scrMarket.value);
      if (event.od[this.game1PlyType])
        event.od[this.game1PlyType] = _.pick(event.od[this.game1PlyType], this.market.scrMarket.value);
      if (event.od[this.game2PlyType])
        event.od[this.game2PlyType] = _.pick(event.od[this.game2PlyType], this.market.scrMarket.value);
      if (event.od[this.game3PlyType])
        event.od[this.game3PlyType] = _.pick(event.od[this.game3PlyType], this.market.scrMarket.value);
      if (event.od[this.game4PlyType])
        event.od[this.game4PlyType] = _.pick(event.od[this.game4PlyType], this.market.scrMarket.value);
      if (event.od[this.game5PlyType])
        event.od[this.game5PlyType] = _.pick(event.od[this.game5PlyType], this.market.scrMarket.value);


      return event
    },
    chooseMarketType(market, event,tab) {

      if (market.flag) {
        this.selectedMarket = market.key
      }
      this.switchAllBetTab(tab)
      this.openMoreBetForm(event,tab)
    },
    sortSpecialEvents(specialEvents) {
      return _.sortBy(specialEvents, ['no'])
    },
    switchAllBetTab(tab) {
      let splitId = tab.split('-').pop();
      // if (tab.includes('cstab')) {
      //   if($('.mmtab-'+splitId).hasClass('active')){
      //     $('.mmtab-'+splitId).removeClass('active');
      //   }
      // }else{
      //   if($('.cstab-'+splitId).hasClass('active')){
      //     $('.cstab-'+splitId).removeClass('active');
      //   }
      // }
      $('.cstab-'+splitId).removeClass('active');
      $('.mmtab-'+splitId).removeClass('active');
      $('.bookingtab-'+splitId).removeClass('active');
      $('.cornertab-'+splitId).removeClass('active');
      
      $(tab).addClass('active');
    },
  },
  mounted(){
  },
  beforeMount() {
    this.allBetRefreshTimer = this.$store.getters.selectedMarket == this.$store.getters.market.inPlayMarket.key ? 30 : 90

    if(this.hasCS) this.selectedMarket = this.mBetTab.cs.key
    else if(this.hasOneX2BTTS) this.selectedMarket = this.mBetTab.onex2btts.key
    else if(this.hasBooking) this.selectedMarket = this.mBetTab.booking.key
    else if(this.hasCorner) this.selectedMarket = this.mBetTab.corner.key
    else this.selectedMarket = this.mBetTab.cs.key  //default cs
    
    this.mainMarketList = _.cloneDeep(this.$store.getters.sortedMatchEventList)
    // this.startAllBetTimer()
    this.getFavCookieMarket()
  },
  destroyed() {
    // this.clearAllBetTimer()
  },
}
</script>

<style lang="scss">
@import "~@/styles/base/global";
// @import "~@/styles/sport/allBet/allBet";
</style>



// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/allBet/more-bet.vue